export function RedPacketEnvelopeCard({
  index,
  selected,
  disabled,
  variant = "newbie-step6",
  onClick
}: {
  index: number;
  selected?: boolean;
  disabled?: boolean;
  variant?: "newbie-step6" | "standard";
  onClick: () => void;
}) {
  const label = `第 ${index + 1} 個紅包`;

  return (
    <button
      aria-label={label}
      aria-pressed={selected}
      className={`rg-redpacket-card ${selected ? "selected" : ""} ${disabled && !selected ? "locked" : ""}`}
      data-variant={variant}
      disabled={disabled && !selected}
      type="button"
      onClick={onClick}
    >
      <span className="rg-redpacket-card-flap" aria-hidden="true" />
      <span className="rg-redpacket-card-mark" aria-hidden="true">
        福
      </span>
      <span className="rg-redpacket-card-shine" aria-hidden="true" />
    </button>
  );
}
